/**
 * RheinNatur: Cart-Drawer öffnen, wenn auf den RN-Produktkarten "In den Warenkorb" geklickt wird
 * (sections/rn-product-card.liquid = Startseite, sections/rn-all-Prod.liquid = Kollektionsseite).
 *
 * Diese Karten legen das Produkt per /cart/add.js in den Warenkorb und feuern danach 'cart:refresh'
 * auf document UND direkt auf <html>. Die Theme-Standard-Buttons (product-form, product-card) öffnen
 * den Drawer selbst und feuern kein Event auf <html>. Darauf hören wir hier: Drawer + Zähler neu
 * laden und den Drawer genauso öffnen wie das Theme (siehe ProductCard.renderContents in app.js).
 */
(function () {
  async function refreshAndOpenCartDrawer() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;

    try {
      var pathname = window.location.pathname;
      var path = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname || '/';
      var res = await fetch(path + '?sections=cart-drawer,cart-bubble');
      var state = await res.json();

      [
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
      ].forEach(function (s) {
        var container = document.getElementById(s.id);
        if (!container || !state[s.section]) return;
        var target = container.querySelector(s.selector) || container;
        var source = new DOMParser().parseFromString(state[s.section], 'text/html').querySelector(s.selector);
        if (source) target.innerHTML = source.innerHTML;
      });

      if (typeof CartDrawer !== 'undefined') new CartDrawer();
    } catch (e) {
      console.error('Cart drawer refresh failed:', e);
    }

    document.body.classList.add('open-cc');
    document.body.classList.add('open-cart');
    drawer.classList.add('active');

    var recommendations = drawer.querySelector('.product-recommendations--full');
    if (recommendations) recommendations.classList.add('active');

    document.dispatchEvent(new CustomEvent('cart-drawer:open', { detail: {} }));
  }

  window.rnOpenCartDrawer = refreshAndOpenCartDrawer;
  document.documentElement.addEventListener('cart:refresh', refreshAndOpenCartDrawer);
})();